var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cargo-pop-select-input" },
    [
      _c("el-input", {
        style: "width: " + _vm.inputWidth + ";",
        attrs: {
          no: "displayName",
          value: _vm.displayName ? _vm.displayName : _vm.eventName
        },
        nativeOn: {
          click: function($event) {
            _vm.dialogVisible = true
          }
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            no: "selectDialog",
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "1160px",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "select-dialog",
              staticStyle: { display: "flex", margin: "10px" }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "align-self": "center", "margin-right": "5px" }
                },
                [_vm._v(_vm._s(_vm.filterLabel) + " ")]
              ),
              _c("el-input", {
                staticStyle: { width: "300px" },
                attrs: {
                  no: "searchValue",
                  placeholder: _vm.$t("SeaExport.PleaseInputAKeyword")
                },
                on: {
                  input: function($event) {
                    _vm.selectedBak = _vm.displayName
                  }
                },
                model: {
                  value: _vm.searchValue,
                  callback: function($$v) {
                    _vm.searchValue = $$v
                  },
                  expression: "searchValue"
                }
              }),
              _vm.showOffice
                ? _c(
                    "span",
                    {
                      staticStyle: {
                        "align-self": "center",
                        "margin-left": "15px",
                        "margin-right": "5px"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_SelectBranch")) + " "
                      )
                    ]
                  )
                : _vm._e(),
              _vm.showOffice
                ? _c(
                    "el-select",
                    {
                      ref: "select",
                      staticStyle: { width: "218px" },
                      attrs: { multiple: "", filterable: "" },
                      on: { "visible-change": _vm.onVisibleChange },
                      model: {
                        value: _vm.branchIds,
                        callback: function($$v) {
                          _vm.branchIds = $$v
                        },
                        expression: "branchIds"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { value: 0, label: _vm.$t("Message.All") }
                      }),
                      _vm._l(_vm.currentOfficeList, function(office) {
                        return _c("el-option", {
                          key: office.uuid,
                          attrs: { value: office.officeId, label: office.code }
                        })
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm.showBranchSelectBtn
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.showBranchSelectDialog }
                    },
                    [_vm._v("...")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "grid" },
            [
              _c("cargo-ag-grid", {
                staticStyle: { height: "100%", "min-height": "400px" },
                attrs: {
                  "column-defs": _vm.columnDefs,
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.filterData,
                  "show-side-bar": false
                }
              })
            ],
            1
          ),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticStyle: { display: "flex", "text-align": "left" } },
              [
                _c("span", { staticClass: "blue" }, [
                  _vm._v(
                    _vm._s(_vm.$t("CargoMsg.Cargo_CurrentSelection")) + ":"
                  )
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      flex: "1",
                      height: "28px",
                      "overflow-y": "auto",
                      "text-align": "left",
                      "word-break": "break-word",
                      "margin-left": "5px"
                    }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.displayName ? _vm.displayName : _vm.eventName
                        ) +
                        " "
                    )
                  ]
                )
              ]
            ),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { no: "confirm", type: "primary" },
                    on: { click: _vm.onSave }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                ),
                _c(
                  "el-button",
                  { attrs: { no: "reset" }, on: { click: _vm.onReset } },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Reset")))]
                ),
                _c(
                  "el-button",
                  { attrs: { no: "cancel" }, on: { click: _vm.handleClose } },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                )
              ],
              1
            )
          ]),
          _c("branch-select-dialog", {
            attrs: {
              "append-to-body": true,
              visible: _vm.branchSelectDialog.visible,
              value: _vm.branchSelectDialog.value,
              "office-list": _vm.currentOfficeList
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.branchSelectDialog, "visible", $event)
              },
              callback: _vm.branchSelectDialog.callback
            }
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }